// Need to use the React-specific entry point to import createApi
import {apiSlice} from './apiSlice';

export const claimApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getClaims: builder.query({
      query: filter => {
        const qs = new URLSearchParams(filter).toString();
        return 'claim' + (qs ? '?' + qs : '');
      },
      providesTags: [
        'Claim', 
        'Session', 
        'Case', 
        'PayerPlan', 
        'Payer', 
        'Patient', 
        'Provider',
      ],
    }),
    updateClaim: builder.mutation({
      query: ({id, body}) => ({
        url: `claim/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Claim'],
    })
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetClaimsQuery,
  useUpdateClaimMutation,
} = claimApi;
